import Vue from 'vue';
import VueRouter, { NavigationGuard, } from 'vue-router';
import { multiGuard, } from '~/utils/vue-router-multiguard';
import Index from './pages/index.vue';
import { Store, } from './store';

Vue.use(VueRouter);

const prefix = '/move-in';
const RequiresUserDetails: NavigationGuard = (to, _from, next) => {
	if (to.path === prefix) {
		next();
		return;
	}

	// eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
	if (!Store.getters.hasExistingUserDetails) {
		next('/');
		return;
	}

	next();
};

// const RequiresBankDetails: NavigationGuard = (_to, _from, next) => {
// 	if (!Store.getters.hasPaymentDetails) {
// 		Store.commit.informReenterPaymentDetails(true);
// 		next('./payment-details');
// 		return;
// 	}

// 	next();
// };

export const Router = new VueRouter({
	base: prefix,
	mode: 'history',
	scrollBehavior() {
		return { x: 0, y: 0, };
	},
	routes: [
		{
			path: '/',
			component: {
				// eslint-disable-next-line @typescript-eslint/no-explicit-any
				render: (c: any) => c('router-view'),
			},
			children: [
				{ path: `moving-details`, component: () => import('./pages/moving-details.vue').then((m) => m.default), },
				{ path: `your-details`, component: () => import('./pages/your-details.vue').then((m) => m.default), },
				{ path: `payment-details`, component: () => import('./pages/payment-details.vue').then((m) => m.default), },
				{ path: `bank-details`, component: () => import('./pages/bank-details.vue').then((m) => m.default), },
				{
					path: `check-details`,
					component: () => import('./pages/check-details.vue').then((m) => m.default),
					beforeEnter: multiGuard([RequiresUserDetails,]),
				},
				{
					path: `set-login-details`,
					component: () => import('./pages/set-login-details.vue').then((m) => m.default),
					beforeEnter: multiGuard([RequiresUserDetails,]),
				},
				{
					path: `thank-you`,
					component: () => import('./pages/thank-you.vue').then((m) => m.default),
					beforeEnter: multiGuard([RequiresUserDetails,]),
				},
				{
					path: `successful`,
					component: () => import('./pages/thank-you.vue').then((m) => m.default),
					beforeEnter: multiGuard([RequiresUserDetails,]),
				},
				{ path: `terms-conditions`, component: () => import('./pages/terms-conditions.vue').then((m) => m.default), },
				{ path: `sew`, component: () => import('./pages/sew.vue').then((m) => m.default), },
				{ path: `meter-upgrade`, component: () => import('./pages/meter-upgrade.vue').then((m) => m.default), },
				{ path: '', component: Index, },
			],
		},
	],
});

Router.afterEach((to) => {
	Store.commit.setActiveAlert(to.fullPath);
});
